import { render, staticRenderFns } from "./MediaTable.vue?vue&type=template&id=57c9de49&scoped=true"
import script from "./MediaTable.vue?vue&type=script&lang=js"
export * from "./MediaTable.vue?vue&type=script&lang=js"
import style0 from "./MediaTable.vue?vue&type=style&index=0&id=57c9de49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c9de49",
  null
  
)

export default component.exports